var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Btn',{attrs:{"label":_vm.$t('ELE0015'),"icon":"mdi-magnify","disabled":_vm.disabled},on:{"click":_vm.onClick}})}
var staticRenderFns = []

export { render, staticRenderFns }